import { HTTP } from './http-common'

export default {
  getHomeProducts(region) {
    return new Promise((resolve, reject) => {
      let payload = {
        ImovelOrigemId: 3,
        IdEstado: region,
        BuscarPorGeolocalizacao: region === null,
      }

      HTTP.post('/imovel/destaques-home', payload).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getManifestVideo(region) {
    return new Promise((resolve, reject) => {
      let payload = { ImovelOrigemId: 3, IdCidade: region }
      HTTP.get(`https://rest.cyrela.com.br/apicyrela/api/home/principal?idImovelOrigem=${payload.ImovelOrigemId}&idCidade=${payload.IdCidade}`).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getAllProducts({ region, city, neighborhood }) {
    return new Promise((resolve, reject) => {
      let payload = { ImovelOrigemId: 3, IdEstado: region, IdCidade: city, IdBairro: neighborhood }
      HTTP.post('/imovel/produto-por-estado', payload).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getProductBySlug(payload) {
    return new Promise((resolve, reject) => {
      HTTP.post('/imovel/informacoes/', { Url: payload }).then(response => {
        if (response.data) {
          resolve(response.data)
        }
      })
        .catch(error => {
          reject(error)
        })
    })
  },

  getProductById(payload) {
    return new Promise((resolve, reject) => {
      HTTP.post('/imovel/informacoes/', { IdImovel: payload }).then(response => {
        if (response.data) {
          resolve(response.data)
        }
      })
        .catch(error => {
          reject(error)
        })
    })
  },

  getLPContent(payload) {
    return new Promise((resolve, reject) => {
      HTTP.post('/lp/informacoes/', payload).then(response => {
        if (response.data) {
          resolve(response.data)
        }
      })
        .catch(error => {
          reject(error)
        })
    })
  },

  getLPHouseVivaz() {
    return new Promise((resolve, reject) => {
      HTTP.get('/api/CasaVivaz/Informacoes').then(response => {
        if (response.status === 200) {
          resolve(response.data)
        }
      })
        .catch(error => {
          reject(error)
        })
    })
  },

  getLocationById(id) {
    return new Promise((resolve, reject) => {
      HTTP.post('/imovel/localizacao/', { IdImovel: id })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  getRecreationById(id) {
    return new Promise((resolve, reject) => {
      HTTP.post('/imovel/lazer/', { IdImovel: id })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getPlantById(id) {
    return new Promise((resolve, reject) => {
      HTTP.post('/imovel/plantas/', { IdImovel: id }).then(response => {
        resolve(response.data)
      })
        .catch(error => {
          reject(error)
        })
    })
  },
  getFacilitiesById(id) {
    return new Promise((resolve, reject) => {
      HTTP.post('/imovel/diferenciais/', { IdImovel: id }).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getvideoByIdState(payload) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/api/estado/video-ficha-produto/${payload.id}/${payload.IdImovel}`).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getCustomLpContent(url) {
    return new Promise((resolve, reject) => {
      HTTP.post('/landingpage/lp-vivaz', url).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/products.js